import styled from "styled-components";
import { device } from "../../../utils/helpers/breakpoints";

export const MessageItemContainer = styled.div`
  animation-delay: 0.8s;
  display: flex;
  justify-content: ${(props) => (props.user === "ME" ? "flex-end" : "")};
  margin: 0.5rem 0rem;
`;

export const MessageItem = styled.div`
  color: ${(props) => (props.user === "ME" ? "white" : "#1a5304")};
  max-width: 50%;

  span {
    margin-top: 2px;
  }

  @media ${device.tablet} {
    padding: 0.5rem 0.5rem;
    max-width: 80%;
  }
`;

export const Message = styled.div`
  background: ${(props) => (props.user === "ME" ? "#1a5304" : "white")};
  color: ${(props) => (props.user === "ME" ? "white" : "#1a5304")};
  border: ${(props) => (props.user === "ME" ? "" : "1px solid #1a5304")};
  padding: 0.5rem;
  border-radius: 1rem;

  span {
    margin-top: 2px;
  }

  @media ${device.tablet} {
    // padding: 0.5rem 0.5rem;
  }
`;

export const TimeContainer = styled.div`
  text-align: right;
  color: #1a5304;
  font-size: 10px;
`;

export const SenderHeader = styled.div`
  color: ${(props) => (props.user === "ME" ? "white" : "#1a5304")};
  font-size: 10px;
  font-weight: bolder;
  margin-bottom: 0.5rem;
`;
